import { createContext, useContext } from "react";
import { AuthContextValue } from "./types";

const noop = async () => {
  /* placeholder */
};

export const AuthContext = createContext<AuthContextValue>({
  isAuthenticated: false,
  isLoading: true,
  user: null,
  error: null,
  login: noop,
  logout: noop,
  getToken: async () => null,
});

export function useAuth(): AuthContextValue {
  return useContext(AuthContext);
}
